import type { TableView } from 'owa-mail-list-store';
import { isGroupTableQuery } from 'owa-group-utils';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export default function getIsArchivePolicyEnabled(tableView: TableView): boolean {
    if (tableView && isGroupTableQuery(tableView.tableQuery)) {
        return false;
    }

    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2532 (13,14): Object is possibly 'undefined'.
    // @ts-expect-error
    return !!getUserConfiguration().SessionSettings.HasArchive;
}
